module.exports = __webpack_public_path__ + "img/pitch_b.139f2106.svg";